import {
	GetAssessmentActionsTypes, GetAssessmentsActionsTypes, CreateAssessmentActionsTypes, UpdateAssessmentActionsTypes, DeleteAssessmentActionsTypes,
	IAssessmentsState,
	AssessmentActions,
} from './types';

const initialState : IAssessmentsState = {
	assessments:[],
    selectedAssessment:{},
	selectedId: -1,
    loading: false,
    error: '',
    success: false,
	create: {
        loading: false,
        error: '',
        success: false,
    },
	update: {
        loading: false,
        error: '',
        success: false,
    },
	delete: {
        loading: false,
        error: '',
        success: false,
    }
};

const assessmentsReducer = (state: IAssessmentsState = initialState, action: AssessmentActions) => {
	switch (action.type) {
		
		// ----------------------Get Assessment Actions-----------------------
		case GetAssessmentActionsTypes.GET_ASSESSMENT: {
			return {
				...state,
				loading: true
			};
		}
		case GetAssessmentActionsTypes.GET_ASSESSMENT_SUCCESS: {
			const { loading, data} = action;
			return {
				...state,
				data: data.data,
				loading, success: true
			};
		}
		case GetAssessmentActionsTypes.GET_ASSESSMENT_ERROR: {
			const { error, loading } = action;
			return {
				...state,
				loading: false, success: false, error: error
			};
		}

		// ----------------------Get Assessments Actions-----------------------
		case GetAssessmentsActionsTypes.GET_ASSESSMENTS: {
			return {
				...state,
				loading: true
			};
		}
		case GetAssessmentsActionsTypes.GET_ASSESSMENTS_SUCCESS: {
			const { loading, data} = action;
			return {
				...state,
				loading, 
				success: true,
				assessments: data.data.assessments,
				create: { success: false, loading: false, error: '' },
				update: { success: false, loading: false, error: '' },
				delete: { success: false, loading: false, error: '' }
			};
		}	
		case GetAssessmentsActionsTypes.GET_ASSESSMENTS_ERROR: {
			const { error, loading } = action;
			return {
				...state,
				loading: false, success: false, error: error
			};
		}				

		// ----------------------Create Assessment Actions-----------------------
		case CreateAssessmentActionsTypes.POST_CREATE_ASSESSMENT: {
			return {
				...state,
				create: { loading: true, success: false, error: '' }
			};
		}
		case CreateAssessmentActionsTypes.POST_CREATE_ASSESSMENT_SUCCESS: {
			return {
				...state,
				create: { success: true, loading: false, error: '' }
			};
		}	
		case CreateAssessmentActionsTypes.POST_CREATE_ASSESSMENT_ERROR: {
			const { error } = action;
			return {
				...state,
				create: { success: false, loading: false, error: error || 'Failed to create assessment' }
			};
		}				

		// ----------------------Update Assessment Actions-----------------------
		case UpdateAssessmentActionsTypes.PUT_UPDATE_ASSESSMENT: {
			return {
				...state,
				update: { loading: true, success: false, error: '' }
			};
		}
		case UpdateAssessmentActionsTypes.PUT_UPDATE_ASSESSMENT_SUCCESS: {
			return {
				...state,
				update: { success: true, loading: false, error: '' }
			};
		}	
		case UpdateAssessmentActionsTypes.PUT_UPDATE_ASSESSMENT_ERROR: {
			const { error } = action;
			return {
				...state,
				update: { success: false, loading: false, error: error || 'Failed to update assessment' }
			};
		}				

		// ----------------------Delete Assessment Actions-----------------------
		case DeleteAssessmentActionsTypes.DELETE_ASSESSMENT: {
			return {
				...state,
				delete: { loading: true, success: false, error: '' }
			};
		}
		case DeleteAssessmentActionsTypes.DELETE_ASSESSMENT_SUCCESS: {
			return {
				...state,
				delete: { success: true, loading: false, error: '' }
			};
		}	
		case DeleteAssessmentActionsTypes.DELETE_ASSESSMENT_ERROR: {
			const { error } = action;
			return {
				...state,
				delete: { success: false, loading: false, error: error || 'Failed to delete assessment' }
			};
		}
				
		default:
			return state;
	}
};

export default assessmentsReducer;
